import PropTypes from 'prop-types'
import { Link } from 'react-router'

/**
 * Generic Error Page
 *
 * This is a generic error page that can be used for any error, but defaults to
 * a 404 type page.
 *
 * @param {*} props
 * @param {*} props.heading - The heading of the error page
 * @param {*} props.message - The message of the error page
 * @param {*} props.buttonLink - The link to redirect to when the button is clicked (default: '/')
 * @param {*} props.buttonText - The text of the button (default: 'Go back home')
 */
function ErrorPage({
  heading = 'Page not found.',
  message = "Sorry, we couldn't find the page you're looking for.",
  buttonLink = '/',
  buttonText = 'Go back home',
}) {
  return (
    <div className="flex h-full w-full flex-col bg-white pt-16 pb-12">
      <main className="mx-auto flex w-full max-w-7xl grow flex-col justify-center px-4 sm:px-6 lg:px-8">
        <div className="py-16">
          <div className="text-center">
            <h1>{heading}</h1>
            <p className="mt-2 text-base text-gray-500">{message}</p>
            <div className="mt-6">
              <Link
                to={buttonLink}
                className="text-primary text-base font-medium hover:underline"
                reloadDocument
              >
                {buttonText}
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

ErrorPage.propTypes = {
  heading: PropTypes.string,
  message: PropTypes.string,
  buttonLink: PropTypes.string,
  buttonText: PropTypes.string,
}

export default ErrorPage
